module.exports = __webpack_public_path__ + "static/img/Bachelor_010753.97fcedd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010753.jpg
// module id = 243
// module chunks = 0